var React = require('react');

function Circles (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;opacity:0.5;}.cls-2{stroke-width:3px;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M211.25,208.28A206.39,206.39,0,0,0,150.39,61.36,206.39,206.39,0,0,0,3.47.5c-1,0-2,0-3,0v85c1,0,2,0,3,0a122.94,122.94,0,0,1,122.8,122.8","key":0}),React.createElement("path",{"className":"cls-2","d":"M94.75,207.9A93.49,93.49,0,0,0,2.5,114.42V207.9","key":1})]))]);
}

Circles.defaultProps = {"viewBox":"0 0 211.75 208.28"};

module.exports = Circles;

Circles.default = Circles;
